module.exports = __webpack_public_path__ + "img/hdh-logo.f7d77984.png";